import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";
import StaffListContent from "./StaffListContent";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import StaffListContentMobile from "./StaffListContentMobile";
import MenuIcon from "@mui/icons-material/Menu";

export default function ContactsList() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <StaffListContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={1} />
          <StaffListContent />
        </>
      )}
    </div>
  );
}
